import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-18 ant-col-xl-10" }
const _hoisted_3 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24" }
const _hoisted_8 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = {
  key: 1,
  class: "ant-row",
  style: {"margin-top":"10px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-21" }, null, -1)
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.props.editar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, {
              label: "Colaborador",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_colaborador, {
                  "codigo-selecionado": _ctx.state.colaboradorSelecionado,
                  "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.colaboradorSelecionado) = $event)),
                  "descricao-selecionado": _ctx.state.nomeSelecionado,
                  "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.nomeSelecionado) = $event)),
                  empresas: _ctx.props.empresas
                }, null, 8, ["codigo-selecionado", "descricao-selecionado", "empresas"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, {
              label: "Comissão",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_campo_numerico, {
                  percentual: true,
                  valor: _ctx.state.comissaoSelecionada,
                  "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.comissaoSelecionada) = $event))
                }, null, 8, ["valor"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, {
              label: "Observação",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  class: "ant-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.observacao) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.observacao]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, {
              label: " ",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-primary",
                  style: {"width":"100%"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.inserirComissao && _ctx.inserirComissao(...args)))
                }, _toDisplayString(_ctx.state.indexSelecionado === -1 ? 'Adicionar' : 'Editar'), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.computedComissoes.length > 0)
          ? (_openBlock(), _createBlock(_component_a_table, {
              key: 0,
              columns: _ctx.state.colunasGrade.filter(item => item.visible),
              "data-source": _ctx.computedComissoes,
              rowKey: "codigo",
              pagination: false,
              size: "small"
            }, {
              bodyCell: _withCtx(({ column, index, text }) => [
                (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.props.editar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.editarComissao(index))
                            }, [
                              _createVNode(_component_icone, { nome: "editar" })
                            ], 8, _hoisted_9),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.excluirComissao(index))
                            }, [
                              _createVNode(_component_icone, { nome: "excluir" })
                            ], 8, _hoisted_10)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararPorcentagem)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2) + '%'), 1))
                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString('R$' + _ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(text), 1))
              ]),
              _: 1
            }, 8, ["columns", "data-source"]))
          : (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 1,
              mensagem: "Nenhuma comissão adicionada."
            }))
      ])
    ]),
    (_ctx.props.editar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-danger",
                  style: {"width":"100%"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.recalcularComissao && _ctx.recalcularComissao(...args)))
                }, "Recalcular Comissões")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}